<template>
	<div >
		<!-- 
		/hkt/customer/add_customer_tag 
		 
		 -->
		<!-- 添加标签 -->
		
		
		<el-dialog :show-close="show_closer" :title="dialogname" :visible.sync="show"
			:close-on-click-modal="close_modal" :close-on-press-escape="close_press" width="800px"
			:lock-scroll="lock_scrol" :before-close="handleClose">
			
			
			<el-form ref="form"  label-width="100px">
				<el-form-item label="标签选择">
					<div class="label_column" >
						<div class="label_clos" v-for="(item, index) in labellist">
							<div class="tit">
								{{item.name || ''}}
							</div>
							<div class="label_lists">
								<div class="label_item"  :class="{isActive: item2.checked}" @click="ToggleLabel(item2)" v-for="(item2, index2) in item.tag">
									<span>
										{{item2.name || ''}}
									</span>
									<div class="la_isAct">
										<i class="el-icon-check"></i>
									</div>
								</div>
							</div>
						</div>
					</div>
								
				</el-form-item>
			</el-form>
			
		
			
			<div class="dialog-footer" slot="footer">
				<el-button class="b save comkl" @click="save_comkl">保 存</el-button>
				<el-button class="b" @click="handleClose">取 消</el-button>
				
			</div>
		
		
		
		</el-dialog>
		<!--  -->
		
	</div>
</template>

<script>
	var that

	import {
	
		
		getCustomerTagList,
		
		editCustomerInfoTag,
	} from 'network/hk_customer'
	export default {
		
		name: "addlabels",
		props: {
			// 
			//
			show: {
				type: Boolean,
				default: false,
			},
			
			customer_id: {
				type: Number | String,
				default: 0,
			},
			checklist:{
				type: Array,
				default: ()=>{
					return []
				},
			},
			
			
		
			
			// 是否显示关闭按钮
			show_closer: {
				type: Boolean,
				default: true,
			},
			// 是否可以通过点击 modal 遮罩层 关闭 Dialog
			close_modal: {
				type: Boolean,
				default: false,
			},
			// 是否可以通过按下 ESC 关闭 Dialog
			close_press: {
				type: Boolean,
				default: true,
			},
			// 是否在 Dialog 出现时将 body 滚动锁定
			lock_scrol: {
				type: Boolean,
				default: false,
			},
			
			dialogname: {
				type: String,
				default: '添加标签',
			},
			
		},
		data() {
			return {
			
				
				urlhead: 'https://scrm.51kuaiding.com/scrm/hktxcx/customer',
				
				labellist: [],
			
			}
		},

		created() {
			that = this
			// 
			
			
		},
		watch: {
			show(){
				if(this.show) {
					
					this.fn_getTagList()
				}
			},
		},
		methods: {
			// 获取标签列表
		
			ToggleLabel(item) {
				console.log(item,'ToggleLabel')
				// let obj = this.labellist[index1].tag[index2]
				
				item.checked = !item.checked
			
			},
			save_comkl(){
				if(this.customer_id) {
					let tag_id = []
					for(let item of this.labellist) {
						for(let item2 of item.tag) {
							if(item2.checked) {
								tag_id.push(item2.id)
							}
						}
					} 
					this.fn_editInfoTag(this.customer_id, 1, tag_id.join(','))
				}
				
			},
			// 编辑客户信息标签
			fn_editInfoTag(customer_id, tag_type, tag_id) {
				editCustomerInfoTag(customer_id, tag_type, tag_id).then(res => {
					if (res.code === 10000) {
						
						this.labellist = []
						this.alertMess('修改成功')
						this.$emit("fnsuccess");
					}
				})
			},
			
			fn_getTagList() {
				getCustomerTagList(999).then(res => {
					if (res.code === 10000) {
						let obj = res.result.data
						if(obj.length) {
							for(let item of obj) {
								if(item.tag.length){
									
									
									for(let tai of item.tag) {
										if(this.checklist) {
											let findex = this.checklist.findIndex(w=>w.id == tai.id)
											
											if(findex != -1) {
												tai.checked = true
											}
											else {
												tai.checked = false
											}
										}
										else {
											tai.checked = false
										}
										
										
									}
								}
							}
						}
						
						this.labellist = obj
						console.log(this.labellist,'this.labellist')
					}
				})
			},
			
			
			
			
			// 弹出  点击遮罩和 x 关闭弹出
			handleClose(done) {
				this.$emit('update:show', false)
			},
			
			


			// 弹出提示
			alertMess(message, type) {
				this.$message({
					showClose: true,
					offset: 100,
					duration: 2000,
					message,
					type: type ? type : 'success',
				});
			},
			handlereq(res) {
				if (res) {
					if (res.code === 10000) { // 请求成功
						return true
					} else { // 请求发生错误
						this.alertMess(res.message, 'error')
						return false
					}
				}
			},


		}
	}
</script>

<style scoped lang="scss">
	
	.comkl {
		background-color: #2a75ea !important;
		color: #fff !important;
	}
	.label_column{
		.label_clos{
			margin-bottom: 30px;
			.tit{
				font-size: 14px;
				color: rgba(96, 98, 102, 1);
				margin-bottom: 14px;
			}
			.label_lists{
				display:flex;
				flex-wrap: wrap;
				
				.label_item::after{
					z-index: 9;
					position: absolute;
					bottom: -9px;
					right: -9px;
					content:'';
					display: none;
					width: 20px;
					height: 20px;
					background-color: var(--themeColor);
					background-color: rgba(42, 117, 234, 1);
					transform:rotate(45deg) ;
				}
				
				.label_item.isActive{
					
					border: 1px solid  rgba(42, 117, 234, 1);
					color:  rgba(42, 117, 234, 1);
					.la_isAct{
						display: block;
					}
				}
				.label_item.isActive::after{
					display: block;
				}
				
				
				.label_item{
					cursor: pointer;
					margin: 0 24px 6px 0;
					width: 110px;
					height: 36px;
					display:flex;
					align-items: center;
					justify-content: center;
					position: relative;
					border-radius: 3px;
					background: rgba(248, 249, 251, 1);
					overflow: hidden;
					span{
						font-size: 14px;
						color: rgba(56, 56, 56, 1);
					}
					.la_isAct{
						z-index: 10;
						position: absolute;
						bottom: 1px;
						right: -3px;
						display: none;
						height: 20px;
						i{
							color:#fff;
							font-size: 14px;
						}
					}
					
					
				}
			}
		}
	}
		
	
	
</style>
